import { SvgIcon, SvgIconProps } from "@mui/material";
import type { JSX } from "react";

export const RoomsIcon = (props: SvgIconProps): JSX.Element => (
  <SvgIcon viewBox="0 0 37 33" fill="none" {...props}>
    <g clipPath="url(#clip0_1660_3781)">
      <path
        d="M35.6201 0.808594H0.810059V31.8086H35.6201V0.808594Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        fill="none"
      />

      <path d="M19.8 0.808594V5.10859" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" />

      <path d="M19.8 9.98047V21.5905" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" />

      <path d="M19.8 27.668V31.808" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" />

      <path d="M0.810059 13.4688L7.30006 13.5487" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" />

      <path d="M19.8 13.4688H13.63" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" />

      <path d="M19.8 17.8477L24.51 17.9277" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" />

      <path d="M35.6301 17.8477H31.3201" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" />
    </g>

    <defs>
      <clipPath id="clip0_1660_3781">
        <rect width="36.44" height="32.62" fill="white" />
      </clipPath>
    </defs>
  </SvgIcon>
);
